import React, { useEffect, useState } from "react";

import RetailHeader from "../../components/header/RetailHeader";
import Hero from "../../components/hero/Hero";
import Footer from "../../../../components/footer/Footer";
import "./RetailHome.css";
import VendorList from "../../components/vendor/VendorList";
import ProductList from "../../components/products/ProductList";

const RetailHome: React.FC = () => {
  return (
    <>
      <div className="retail__home__page" id="home">
        <Hero />
        <VendorList />
        <ProductList />
      </div>
      {/* <Footer /> */}
    </>
  );
};

export default RetailHome;
